<template>
  <div :class="['timeline-badge', color]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'timeline-badge',
  props: {
    color: String
  }
};
</script>

<style>
  .timeline-badge {
    color: #fff;
    width: 50px;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    top: 16px;
    left: 50%;
    margin-left: -25px;
    background-color: #aea79f;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    -moz-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 3px 0 rgba(0, 0, 0, 0.2);
  }

  .timeline-badge.primary {
    background-color: #21BBEF !important;
  }

  .timeline-badge.success {
    background-color: #1caf9a !important;
  }

  .timeline-badge.warning {
    background-color: #efb73e !important;
  }

  .timeline-badge.danger {
    background-color: #df382c !important;
  }

  .timeline-badge.info {
    background-color: #772953 !important;
  }

  .timeline-badge.default {
    background-color: rgba(166, 158, 151, .3) !important;
  }

  @media (max-width: 992px) {
    .timeline-badge {
      left: 7%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/UIComponents/Timeline/TimelineBadge.vue